/** Mirrors App.tsx admin rules so feature areas can hide admin-only affordances. */

export const getAdminEmails = (): string[] => {
  const envEmails = typeof process !== 'undefined' ? process.env.REACT_APP_ADMIN_EMAILS : undefined;
  const windowEmails = typeof window !== 'undefined' ? (window as unknown as { REACT_APP_ADMIN_EMAILS?: string }).REACT_APP_ADMIN_EMAILS : undefined;
  const raw = envEmails || windowEmails || '';
  return raw
    .split(',')
    .map((email: string) => email.trim().toLowerCase())
    .filter(Boolean);
};

export const getAdminDomain = (): string => {
  const envDomain = typeof process !== 'undefined' ? process.env.REACT_APP_ADMIN_DOMAIN : undefined;
  const windowDomain = typeof window !== 'undefined' ? (window as unknown as { REACT_APP_ADMIN_DOMAIN?: string }).REACT_APP_ADMIN_DOMAIN : undefined;
  return (envDomain || windowDomain || 'netsertive.com').toLowerCase();
};

export const isAdminUser = (email?: string): boolean => {
  if (!email) return false;
  const normalized = email.toLowerCase();
  const qaExclusions = ['qa1@netsertive.com', 'qa2@netsertive.com'];
  if (qaExclusions.includes(normalized)) return false;
  const adminEmails = getAdminEmails();
  if (adminEmails.includes(normalized)) return true;
  const adminDomain = getAdminDomain();
  return normalized.endsWith(`@${adminDomain}`);
};
